const hero = {
	gradientMap: {
		green: 'linear-gradient(90deg, rgb(13, 177, 188) 0%, rgb(176, 210, 53) 100%)',
		blue: 'linear-gradient(90deg, #07428A 0%, #00AEEF 100%)',
		purple: 'linear-gradient(90deg, rgb(112, 56, 137) 0%, rgb(103, 139, 199) 100%)',
		disabled: 'none',
	},

	init() {
		this.initializeHeroSliders();
	},

	initializeHeroSliders() {
		const heroSliders = document.querySelectorAll('[data-hero-slider]');
		if (!heroSliders.length) {
			return;
		}

		heroSliders.forEach(slider => this.setupSlider(slider));
	},

	setupSlider(slider) {
		const slides = slider.querySelectorAll('.swiper-slide');
		const {gradientEl, colorEl, paginationEl} = this.getSliderElements(slider);

		if (slides.length < 2) {
			this.updateStyles(slider, slides, gradientEl, colorEl, 0);
			return;
		}


		const swiper = new Swiper(
			slider,
			{
				loop: true,
				slidesPerView: 1,
				autoplay: {
					delay: 5000,
				},
				pagination: {
					el: paginationEl,
					clickable: true,
				},
				on: {
					init: () => this.updateStyles(swiper, slides, gradientEl, colorEl, 0),
					slideChangeTransitionStart: (swiper) =>
						this.updateStyles(swiper, slides, gradientEl, colorEl, swiper.realIndex),
				},
			}
		);
	},

	getSliderElements(slider) {
		const heroContainer = slider.closest('.hero');
		return {
			gradientEl: heroContainer.querySelector('[data-hero-gradient]'),
			colorEl: heroContainer.querySelector('[data-hero-color]'),
			paginationEl: heroContainer.querySelector('[data-hero-pagination]'),
		};
	},

	updateStyles(swiper, slides, gradientEl, colorEl, index) {
		const currentSlide = slides[index];
		const color = currentSlide.querySelector('[data-color]').dataset.color;
		const gradient = currentSlide.querySelector('[data-gradient]').dataset.gradient;

		gradientEl.style.background = this.gradientMap[gradient] || this.gradientMap['disabled'];
		colorEl.style.background = color;
	},
};

export default hero;
hero.init();
